import { Component, ContentChild, Input, OnInit, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-stat-card',
  templateUrl: './stat-card.component.html',
  styleUrls: ['./stat-card.component.scss']
})
export class StatCardComponent implements OnInit {

  @ContentChild('statCard', {static: false}) statCard!: TemplateRef<any>;
  @Input() cardList!: any[];

  ngOnInit() {
    this.cardList = this.cardList || [];
  }

}
